import React from 'react'
import { Outlet } from 'react-router-dom'
import Nav from '../../components/site/Nav'
import Footer from '../../components/site/Footer'
import { settings, services } from '../../content/site'
import '../../css/public/layout.css'
import '../../css/public/components.css'
import './index.css'
import '../../css/site/tokens.css'
import '../../css/site/site.css'

const Index = () => {
  return (
    <div className='nv-site'>
        <Nav settings={settings}/>
        <Outlet />
        <Footer settings={settings} services={services}/>
    </div>
  )
}

export default Index
